// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translation: {
    logoAlt: 'Star wars icon',
    navLinks: {
      home: 'Home',
      people: 'People',
      search: 'Search',
      notFound: 'Not found',
    },
    headerText: {
      choose: 'Choose your side',
      search: 'Search',
      favorites: 'Favorites',
    },
    chooseSide: {
      light: 'Light Side',
      dark: 'Dark Side',
      neutral: 'Neutral',
    },
    listNavButtons: {
      prev: 'Previous',
      next: 'Next',
    },
    searchInputPlaceholder: 'Type characters name',
    goBackLink: 'Go back',
    personInfo: {
      height: 'Height',
      mass: 'Mass',
      gender: 'Gender',
      birthYear: 'Birth year',
      hairColor: 'Hair color',
      skinColor: 'Skin color',
      eyeColor: ' Eye color',
    },
    episode: 'Episode {{number}}',
    errors: {
      noDataMessage: 'No data',
      noMatchUrl: 'No match for',
      fetchMessage: 'The dark side of the force has won.\nWe cannot display data.\nCome back when we fix everything.'
    },
  },
};